module.exports = __webpack_public_path__ + "96a8293563023c6fe50737562c19448c.png";